import { isColumnVisibleByDefault } from '../../../utils/partialPermissionUtils';
import {
  createCustomLinkFormatter,
  renderPredecessors,
  fallbackRenderer,
} from '../../../assets/js/custom_gantt_fields/predecessorsFormatter';
import { createDurationFormatter } from '../../../assets/js/custom_gantt_fields/linkFormatterCommon';

export default function customPredecessorsCol(gantt, t) {
  const name = 'custom_predecessors';
  const hide = !isColumnVisibleByDefault(name);

  if (!gantt?.ext?.formatters) {
    return {
      name,
      label: t('gantt.columns.customPredecessors', 'Predecesoras'),
      width: 80,
      align: 'center',
      editor: { type: 'text', map_to: name },
      resize: true,
      template: (activity) => {
        const odd = gantt.oddColsConfig?.[name] || false;
        return `
          <div class="${odd ? 'odd-col' : 'non-odd-col'}" style="font-weight: 100">
            ${fallbackRenderer(activity)}
          </div>
        `;
      },
      hide,
      data_type: 'string'
    };
  }

  const durationFormatter = createDurationFormatter(gantt);
  const linkFormatter = createCustomLinkFormatter(gantt, durationFormatter);

  return {
    name,
    label: t('gantt.columns.customPredecessors', 'Predecesoras'),
    width: 80,
    align: 'center',
    editor: { type: 'text', map_to: name },
    resize: true,
    template: (activity) => {
      const odd = gantt.oddColsConfig?.[name] || false;
      return `
        <div class="${odd ? 'odd-col' : 'non-odd-col'}" style="font-weight: 100">
          ${renderPredecessors(gantt, linkFormatter, activity)}
        </div>
      `;
    },
    hide,
    data_type: 'string'
  };
}
